module.exports = __webpack_public_path__ + "img/settings-10-second.0d82862d.svg";